import axios from "axios"
import { enqueueSnackbar } from "notistack"
import { handleLogoutUser } from "./screens/Logout"

let BASE_URL = process.env.REACT_APP_API_URL

const instance = axios.create()

instance.interceptors.request.use(
    (config) => config,
    (error) => Promise.reject(error),
)

instance.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(error),
)

const http = (method, endpoint, body = {}) => {
    const { headers, apiData, formData } = body

    if (body.baseURL) {
        BASE_URL = body.baseURL
    }

    const url = `${BASE_URL}${endpoint}`

    const configurations = {
        url,
        method,
        headers: {
            "Client-Type": "web",
            Accept: "application/json",
            "Content-Type": "application/json",
            "App-Key": sessionStorage.getItem("app_key") || "master",
            "Auth-Token": localStorage.getItem("token"),
            polling: apiData?.polling,
            "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
            Pragma: "no-cache",
            Expires: "0",
            "ngrok-skip-browser-warning": 123, //for Development only
            "Timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
            ...headers,
        },
        data: formData ? formData : apiData,
        timeout: 20000,
        withCredentials: false,
        responseType: "json",
        validateStatus(status) {
            return status >= 200 && status < 300
        },
    }

    if (method == "GET") {
        configurations.params = apiData
    }

    return instance(configurations)
        .then((result) => {
            const { status } = result

            const data = result.data.data
            if (data) {
                if (typeof data === "object") {
                    result.data.data = data
                } else result.data.data = JSON.parse(data)
                return result.data
            } else return true
        })
        .catch((er) => {
            if (er?.response?.status == 400) {
                const error = new Error(er.response.data.message)
                if (er.response.data?.error?.locked_until) {
                    const lockedUntilDate = new Date(er.response.data?.error?.locked_until)
                    const formattedLockedUntil = lockedUntilDate.toLocaleDateString("en-US", {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                        hour12: true,
                    })
                    let errData = `You have reached the maximum allowed password attempts. Your account is temporarily locked until ${formattedLockedUntil} due to security issues. Please contact the administrator for support.`
                    enqueueSnackbar(errData, {
                        variant: "error",
                        anchorOrigin: {
                            horizontal: "right",
                            vertical: "bottom",
                        },
                    })
                } else {
                    enqueueSnackbar(er.response.data.message, {
                        variant: "error",
                        anchorOrigin: {
                            horizontal: "right",
                            vertical: "bottom",
                        },
                    })
                }

                return error
            } else if (er?.response?.status === 401) {
                const session = sessionStorage.getItem("isLoggedIn")
                if (!session) {
                    handleLogoutUser()
                    return
                }
                alert("You've been logged out due to Inactivity")
                handleLogoutUser()
            } else {
                return er
            }
        })
}

export default http
